<template>
  <div>
    <!--ini -->
    <v-row>
      <!-- <v-btn v-for="abu of miabuelo" :key="abu.id" @click="nombrefuncion(abu.id)">{{abu.name}}</v-btn> <br> -->
      <v-col cols="2" class="">
        <v-col cols="12">
          <v-btn
            class="mx-2 pl-1"
            id="view-fullscreen"
            fab
            dark
            x-small
            color="warning"
            ><v-icon small> fa-desktop</v-icon></v-btn
          >
          <v-btn
            class="mx-2 pl-1"
            id="cancel-fullscreen"
            fab
            dark
            x-small
            color="info"
            ><v-icon small> fa-desktop</v-icon></v-btn
          >
          <v-btn class="primary mt-2" @click="volverAtras">Volver</v-btn>
        </v-col>

        <div>
          <v-container fluid>
            <v-row wrap style="max-height: 700px" class="overflow-y-auto">
              <!-- -->
              <v-alert type="warning" outlined v-if="diapositivas.length === 0">
                Aún no existen diapositivas creadas.
              </v-alert>

              <v-col
                cols="12"
                v-for="(item, index) of diapositivas"
                :key="index"
              >
                <v-card
                  @click="verDiapositivaPregunta(item, index)"
                  class="diapositiva"
                  v-if="
                    item.tipo === 'PM' ||
                    item.tipo === 'PU' ||
                    item.tipo === 'PV'
                  "
                >
                  <v-img
                    src="@/assets/iconos/PU.svg"
                    v-if="item.tipo === 'PU'"
                    class="white--text align-end imagen"
                  ></v-img>
                  <v-img
                    src="@/assets/iconos/PM.svg"
                    v-if="item.tipo === 'PM'"
                    class="white--text align-end imagen"
                  ></v-img>
                  <v-img
                    src="@/assets/iconos/VF.svg"
                    v-if="item.tipo === 'PV'"
                    class="white--text align-end imagen"
                  ></v-img>
                </v-card>

                <v-card
                  v-else
                  @click="verDiapositiva(item)"
                  class="diapositiva"
                >
                  <span
                    v-html="item.titulo"
                    class="text-center"
                    style="font-size: 10px"
                  ></span>

                  <v-img
                    src="@/assets/iconos/1-COL.jpg"
                    v-if="item.tipo === 'C1'"
                    class="white--text align-end imagen"
                  ></v-img>
                  <v-img
                    src="@/assets/iconos/2-COL.jpg"
                    v-if="item.tipo === 'C2'"
                    class="white--text align-end imagen"
                  ></v-img>
                  <v-img
                    src="@/assets/iconos/3-COL.jpg"
                    v-if="item.tipo === 'C3'"
                    class="white--text align-end imagen"
                  ></v-img>
                  <v-img
                    src="@/assets/iconos/4-COL.jpg"
                    v-if="item.tipo === 'C4'"
                    class="white--text align-end imagen"
                  ></v-img>
                </v-card>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>

      <!-- end side -->
      <v-col
        cols="10"
        class="fondo-presentacion"
        v-bind:style="{ backgroundImage: image }"
      >
        <!-- <v-row>
                <v-col cols="12" style="background:#fff;border:2px solid #1565c0;border-radius:8px;box-shadow:0px 5px 5px #D4D8D9;">
                    <h3 style="color:#1565c0;text-transform:uppercase;">{{tituloArea}}</h3>
                </v-col>
                </v-row> -->

        <div>
          <!-- <v-alert type="error" v-if="msj" dismissible>  {{text}}   </v-alert> -->
          <!-- -->
          <v-col cols="12" md="12">
            <component
              :is="vistadiapositiva"
              :presentacion="diapost"
              :preguntas="pregunta"
              :respuestaVerdadera="rv"
              :respuestaUnica="ru"
              :respuestas="rm"
              :opciones="opcs"
              :validar="valid"
              @comprobar="validarRespuesta"
            ></component>
            <!-- <VistaCol01 v-if="panelcol1" :presentacion="diapost"></VistaCol01>
                        <VistaCol02 v-if="panelcol2" :presentacion="diapost"></VistaCol02>
                        <VistaCol03 v-if="panelcol3" :presentacion="diapost"></VistaCol03>
                        <VistaCol04 v-if="panelcol4" :presentacion="diapost"></VistaCol04>
                        <VistaPre1 v-if="contenidopreg1" :presentacion="pregunta" :respuestaVerdadera="rv" :respuestaUnica="ru" :respuestas="rm" @comprobar="validarRespuesta" :opciones="opcs" :validar="valid" ></VistaPre1>-->
          </v-col>
          <!-- -->
        </div>
      </v-col>
    </v-row>

    <!-- -->

    <!-- -->
    <!-- <pre>{{$data}}</pre> -->
  </div>
  <!--end -->
</template>



<script>
import VistaCol01 from "@/views/Manager/CreadorContenido/componentes/vistas/VistaCol01.vue";
import VistaCol02 from "@/views/Manager/CreadorContenido/componentes/vistas/VistaCol02.vue";
import VistaCol03 from "@/views/Manager/CreadorContenido/componentes/vistas/VistaCol03.vue";
import VistaPre1 from "@/views/Manager/CreadorContenido/componentes/vistas/VistaPre1.vue";

import axios from "../../helpers/axios";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "contenidodiapositiva",
  props: ["diapositivas", "dataSet"],

  data() {
    return {
      diapost: [],
      paramComponente: { id_submodulo: 22, id_modulo: 4 },
      pregunta: [],
      vistadiapositiva: "",
      image: "",
      rv: false,
      ru: false,
      rm: false,
      opcs: false,
      valid: true,
      hidentemplate: true,
      //  msj:false,
      //  text:'',
      //  tipo:'',
      api1: [],
      variable: -1,
      vista: false,
      panelcol1: false,
      panelcol2: false,
      panelcol3: false,
      panelcol4: false,
      contenidopreg1: false,
      contenidopreg2: false,
      contenidopreg3: false,
      contenidopreg4: false,
      contenidopreg5: false,
      contenidopreg6: false,
      contenidopreg7: false,
      contenidopreg8: false,
      tipoComponente: "",
      tituloArea: "",
      prueba: [],
      vef: 0,
      vif: 0,

      ruta: {
        clases_id: 0,

        temas_id: 0,

        cursos_id: 0,
      },

      mirror: {
        contenido: {
          tipo: this.tipo,
          id_usuario: sessionStorage.id, // 25-02-2020. Robert. Se elimina la asignación estatica del Id del usuario y se agraga el Seteo de la variable en session
          id_colegio: sessionStorage.id_colegio, // 25-02-2020. Robert. Se elimina la asignación estatica del Id del colegio y se agraga el Seteo de la variable en session
          id_clase: 0, // 25-02-2020. Robert. Se elimina la asignación estatica del Id de la clase en session y se agraga el Seteo de la variable en 0
          titulo: "",
          subtitulo: "",
          seccion1: [],
          seccion2: [],
          desc_contenido: "",
          dificultad: 0,
          panelsw1: true, //panelsw1
          panelsw2: true, //panelsw2
        },
      },

      miabuelo: 0, // 25-02-2020. Robert. Se crea con el fin de probar corrección de error
    };
  },

  mounted() {
    this.fullsc();
    //console.log(this.dataSet)
    //this.cargarFondo(this.dataSet.id_area);
  },

  created() {
    this.actualizarParamentro();
    //console.log(this.props)
  },

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
  },

  methods: {
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      //console.log( `parametroComponente ${JSON.stringify(this.paramComponente)}`)
      this.parametroComponente(this.paramComponente);
    },

    /******volver atras **** */
    volverAtras() {
      this.$emit("irClases");
    },

    validarRespuesta(tipo) {
      if (tipo === "prU") {
        this.ru = true;
      } else if (tipo === "prM") {
        this.rm = true;
        this.opcs = false;
        this.valid = false;
      }
    },

    //////////////////////////////////////////
    cargarFondo(area) {
      switch (area) {
        case 1:
          this.tituloArea = "Ciencias Naturales";
          //this.image = `url(${require('@/assets/fondos-diapositivas/ciencias_naturales.jpg')})`;
          break;
        case 2:
          this.tituloArea = "Ciencia, Tecnologia y Ambiente";
          // this.image = `url(${require('@/assets/fondos-diapositivas/ciencia_ambiente.jpeg')})`;
          break;
        case 3:
          this.tituloArea = "Ciencias Sociales";
          // this.image = `url(${require('@/assets/fondos-diapositivas/ciencias_sociales.jpg')})`;
          break;
        case 4:
          this.tituloArea = "Comunicación";
          // this.image = `url(${require('@/assets/fondos-diapositivas/comunicacion.jpg')})`;
          break;
        case 5:
          this.tituloArea = "Educ. Fisica";
          //  this.image = `url(${require('@/assets/fondos-diapositivas/educ_fisica.jpg')})`;
          break;
        case 7:
          this.tituloArea = "Matemática";
          //this.image = `url(${require('@/assets/fondos-diapositivas/matematica.png')})`;
          break;
        case 8:
          this.tituloArea = "Religión";
          // this.image = `url(${require('@/assets/fondos-diapositivas/religion.jpg')})`;
          break;
        case 9:
          this.tituloArea = "Inclusión";
          break;
        case 10:
          this.tituloArea = "Inglés";
          //this.image = `url(${require('@/assets/fondos-diapositivas/ingles.jpg')})`;
          break;
        default:
          break;
      }
    },

    ////////////////////////////////////////////
    /* ver diapositiva ****/
    async verDiapositiva(item) {
      if (this.vif != item.id) {
        this.diapost = [];
        var id = item.id;
        try {
          let response = await axios.get("/manager/contenido/" + id + "");
          this.prueba = response.data;
          //console.log("tipo:",item.tipo,"data:",JSON.parse(this.prueba[0].json_contenido))
          this.diapost = JSON.parse(this.prueba[0].json_contenido);
          this.rv = false;
          this.ru = false;
          this.verificarColumnas(item.tipo);
          this.vif = item.id;
          //console.log('dipost====>>>'+JSON.stringify(this.diapost.seccion1));
        } catch (error) {
          console.log(error);
        }
      } /* else {
        alert("Ya estás en esta diapositiva.");
      } */
    },

    async verDiapositivaPregunta(item) {
      this.valid = true;
      this.ru = false;
      this.rm = false;
      this.opcs = true;

      if (this.vif != item.id) {
        var id = item.id;
        try {
          let response = await axios.get("/manager/contenido/preg/" + id + "");
          this.pregunta = response.data;
          this.verificando(item.tipo);
          this.vif = item.id;
          //console.log('pregunta====>>>'+JSON.stringify(this.pregunta));
        } catch (error) {
          console.log(error);
        }
      } else {
        alert("ya estas en esta diapositiva");
      }
    },

    verificarColumnas(tipo) {
      if (tipo === "C1") {
        this.vistadiapositiva = "VistaCol01";
      } else if (tipo === "C2") {
        this.vistadiapositiva = "VistaCol02";
      } else if (tipo === "C3") {
        this.vistadiapositiva = "VistaCol03";
      }
    },

    verificando(tipo) {
      if (tipo === "PU" || tipo === "PM" || tipo === "PV") {
        this.vistadiapositiva = "VistaPre1";
      }
    },

    fullsc: function () {
      var viewFullScreen = document.getElementById("view-fullscreen");
      if (viewFullScreen) {
        viewFullScreen.addEventListener(
          "click",
          function () {
            var docElm = document.documentElement;
            if (docElm.requestFullscreen) {
              docElm.requestFullscreen();
            } else if (docElm.msRequestFullscreen) {
              docElm = document.body; //overwrite the element (for IE)
              docElm.msRequestFullscreen();
            } else if (docElm.mozRequestFullScreen) {
              docElm.mozRequestFullScreen();
            } else if (docElm.webkitRequestFullScreen) {
              docElm.webkitRequestFullScreen();
            }
          },
          false
        );
      }

      var cancelFullScreen = document.getElementById("cancel-fullscreen");
      if (cancelFullScreen) {
        cancelFullScreen.addEventListener(
          "click",
          function () {
            if (document.exitFullscreen) {
              document.exitFullscreen();
            } else if (document.msExitFullscreen) {
              document.msExitFullscreen();
            } else if (document.mozCancelFullScreen) {
              document.mozCancelFullScreen();
            } else if (document.webkitCancelFullScreen) {
              document.webkitCancelFullScreen();
            }
          },
          false
        );
      }

      var fullscreenState = document.getElementById("fullscreen-state");
      if (fullscreenState) {
        document.addEventListener(
          "fullscreenchange",
          function () {
            fullscreenState.innerHTML = document.fullscreenElement
              ? ""
              : "not ";
          },
          false
        );

        document.addEventListener(
          "msfullscreenchange",
          function () {
            fullscreenState.innerHTML = document.msFullscreenElement
              ? ""
              : "not ";
          },
          false
        );

        document.addEventListener(
          "mozfullscreenchange",
          function () {
            fullscreenState.innerHTML = document.mozFullScreen ? "" : "not ";
          },
          false
        );

        document.addEventListener(
          "webkitfullscreenchange",
          function () {
            fullscreenState.innerHTML = document.webkitIsFullScreen
              ? ""
              : "not ";
          },
          false
        );
      }
    },
  },

  components: {
    VistaCol01,
    VistaCol02,
    VistaCol03,
    VistaPre1,
  },
};
</script>




<style>
/* Maquetacion */

.a {
  background-color: brown;
}

.b {
  background-color: rgb(15, 221, 170);
}

.c {
  background-color: blueviolet;
}

.d {
  background-color: rgb(3, 86, 124);
}

.fondo {
  margin: 0;
  height: auto;
  background-color: #cccccc; /* Used if the image is unavailable */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}

.fondo-presentacion {
  margin: 0;
  height: auto;
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover;
}

.diapositiva {
  position: relative;
  width: 200px;
  transition: width 4s;
  cursor: pointer;
}

.bag {
  position: absolute;
  width: 50px;
  height: 40px;
  background: red;
}

.imagen {
  position: relative;
}
</style>